
import { defineComponent, PropType } from 'vue'
import DeliveryDatePickerInner from './DeliveryDatePickerInner.vue'
import { IHolidaysConfig } from '@/store/modules/main/intefaces/IConfig'
import AsahiArrow from '@/components/library/assets/AsahiArrow.vue'

type DeliveryDatePickerInnerExpose = {
  openDatePicker: () => void
}

export default defineComponent({
  name: 'DeliveryDatePicker',

  props: {
    modelValue: {
      type: String,
      required: true
    },
    shipmentId: {
      type: String,
      required: true
    },
    holidayDays: {
      type: Object as PropType<Array<IHolidaysConfig>>,
      default: null
    },
    hasArrow: {
      type: Boolean,
      default: false
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    shipToId: {
      type: String,
      required: true
    },
    changeCalenderBgColor: {
      type: Boolean,
      default: false
    }

  },

  emits: ['update:modelValue', 'open', 'close', 'datePickerOpen'],

  components: {
    DeliveryDatePickerInner,
    AsahiArrow
  },

  data: () => ({
    componentKey: 0,
    isDatePickerOpened: false,
    arrowRotated: false,
    openArrowPicker: false
  }),

  methods: {
    forceRecalculate () {
      this.componentKey += 1
    },

    onDatePickerOpened (opened: boolean) {
      this.arrowRotated = opened
      setTimeout(() => {
        this.isDatePickerOpened = opened
        if (opened) {
          this.$emit('open')
        } else {
          this.$emit('close')
        }
      }, 100)
    },
    openTheDatePicker () {
      this.openArrowPicker = !this.openArrowPicker
      console.info('openTheDatePicker: ', this.openArrowPicker)
      this.$emit('datePickerOpen', this.openArrowPicker)
      this.onDatePickerOpened(this.openArrowPicker)

      const datePickerInnerRef = this.$refs.datePickerInnerRef as DeliveryDatePickerInnerExpose | undefined

      if (this.openArrowPicker && datePickerInnerRef?.openDatePicker) {
        datePickerInnerRef.openDatePicker()
      }
    }
  }
})
